export default {
    home: '首页',
    course: '课程',
    teacher: '老师',
    resource: '免费资源',
    class: '如何上课',
    test: '中文水平测试',
    experience: '免费体验课',
    login: '登录',
    register: '注册'
};